/* eslint-disable max-lines */
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import CreateFeed from '@/components/CreateFeed/CreateFeed.vue'
import Comments from "@/components/Comments/Comments.vue";
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import { ref } from "vue";
import { is_organization_admin_role } from "@/utils/organization_profile";
import { view_profile as view_profile_helper } from "@/views/home/home_helper.js";
import {
  customer_profile_social_methods,
  get_profile_request_payload,
  get_profile_route_context,
} from "./customer_profile_route_helper";

const GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;

export default {
  components: {
    HomeNavBar,
    CreateFeed,
    Comments,

  },

  mounted() {
    this.apply_profile_route_context();
    this.user_details = get_user_details();
    this.token_exists = get_token();
    this.fetch_races();
    this.fetch_social_types()
    this.fetch_gender();
    this.fetch_title();
    this.fetch_province();
    this.get_profile();
    this.fetch_memberships();
    this.filter_membership_payment_history();
    this.fetch_type_of_organization();
    this.fetch_type_of_profile();
    this.bind_profile_modal_location_autocomplete();
    this.bind_answer_preview_modal_return();

  },
  beforeUnmount() {
    const profile_modal = document.getElementById('profile_modal');
    if (profile_modal && this.profile_modal_location_handler) {
      profile_modal.removeEventListener('shown.bs.modal', this.profile_modal_location_handler);
    }
    $('#view_answer_modal').off('hidden.bs.modal.profileReturn');
    this.clear_answer_preview_loading_timeout();
    this.clear_profile_page_loading_timeout();
  },
  inject: ['client_features'],

  data() {
    return ({
      user: this.getUserData(),
      races: [], race_id: '',
      genders: [],
      titles: [], title_id: '',
      start_distribution: {},
      new_rating: 0,
      hover_rating: 0,
      new_review_text: '',
      library_resources: [],
      cv: null,
      profile_picture_url: null,
      fileType: '',
      isLocalFile: false,
      local_file_url: null,
      address: this.get_address(),
      rating: 0,
      total_ratings: 0,
      profileData: {},
      likedReports: {},
      reports: [],
      image_view_url: null,
      answer_file_name: '',
      user_details: {
        "user_role": '',
      },
      followers_list: [],
      loading_followers: false,
      token_exists: true,
      is_loading: false,
      isLoading: false,
      profile: {},
      errors: {},
      showPreview: false,
      file_name: '',
      membership_payment_history_id: null,
      membership_payment_history: [],
      membership_name: '',
      membership_type: '',
      membership_price: 0,
      userHasPaid: false,
      billing_cycle: '',
      type_of_profile: [],
      base_profiles: [],
      profile_questions: [],
      renewal_date: null,
      is_active: false,
      is_cancelled: false,
      filtered_profiles: [],
      showVisibilityModal: false,
      currentField: '',
      currentVisibility: true,
      activeTab: 'posts',
      location: '',
      profilePicture: null,
      profile_picture_preview: null,
      fully_answered_sections: {},
      question_page: 1,
      questions_per_page: 5,
      cover_picture: null,
      cover_picture_preview: null,
      membership_available: false,
      currentAnswerVisibility: true,
      is_owner_view: false,
      type_of_followers: true,
      social_platforms: [],
      new_socials: [
        { platform: '', url: '' }
      ],
      comment: '',
      commentText: '',
      active_comment_report_id: null,
      temporaryPost: null,
      currentDate: new Date().toISOString().split('T')[0],
      user_has_rated: false,
      all_ratings: [],
      editing: false,
      session_profile_name: '',
      profile_slug: '',
      profile_type: '',
      names_update_modal_opened: false,
      profile_location_auto_complete: null,
      profile_location_auto_complete_input: null,
      profile_modal_location_handler: null,
      return_to_profile_modal_after_preview: false,
      answer_preview_loading: false,
      answer_preview_loading_timeout: null,
      profile_page_loading: true,
      profile_page_loading_timeout: null,
    });
  },
  setup() {
    const subscriptionExpanded = ref(false);
    const showManagement = ref(false);

    return { subscriptionExpanded, showManagement };
  },
  props: {
    show_navbar: {
      type: Boolean,
      default: true
    },
    business_profiles: {
      type: Array,
      default: () => []
    },
    active_profile_data: {
      type: Object,
      default: null
    },
    selectedLocation: {
      type: String,
      default: ''
    },
  },
  computed: {

    has_loaded_profile() {
      return Boolean(this.profileData?.base_profile?.id || this.profileData?.id);
    },

    can_create_business_profile() {
      return (
        this.is_enabled_feature(this.client_features?.show_business_profiles) ||
        this.is_enabled_feature(this.client_features?.show_business_profile)
      )
        && !is_organization_admin_role(this.user_details);
    },
    can_show_associated_businesses() {
      return (
        this.is_enabled_feature(this.client_features?.show_business_profiles) ||
        this.is_enabled_feature(this.client_features?.show_business_profile)
      ) && this.filtered_profiles.length;
    },

    circleOffset() {
      const radius = 54
      const circumference = 2 * Math.PI * radius
      const percentage = this.profileData?.completion_percentage || 0
      return circumference - (percentage / 100) * circumference
    },

    display_profile_name() {
      const loadedName = [
        this.profileData?.user?.first_name || this.profileData?.first_name || this.user.first_name,
        this.profileData?.user?.last_name || this.profileData?.last_name || this.user.last_name,
      ].filter(Boolean).join(' ');

      return loadedName || this.session_profile_name || '--';
    },
    current_membership_summary() {
      if (!this.client_features.show_membership) {
        return null;
      }

      const membership_name = this.membership_type;
      const is_active = this.is_active;
      if (!membership_name || !is_active) {
        return null;
      }

      return ({
        name: membership_name,
        status: 'Active',
        icon: 'bi-patch-check',
        status_class: 'text-primary'
      });
    },

    all_section() {
      // questions is an array of forms, each with form_sections (sections)
      return (this.profile_questions.flatMap(form =>
        (form.form?.form_sections || []).map(fs => ({
          ...fs,
          formId: form.form?.id,
          formName: form.form?.name,
          section: fs.section,
          sectionId: fs.section?.id
        }))
      ));
    },
    isOwner() {
      if (this.is_owner_view) {
        // If "view as member" mode is active, treat as non-owner
        return false;
      }
      return String(this.profileData?.base_profile?.creater?.id) === String(this.user_details.user_id);
    },

    rating_level() {
      return ['', 'Terrible', 'Poor', 'Average', 'Good', 'Excellent'][this.hover_rating || this.new_rating] || 'Tap a star to rate';
    },
    todayDate() {
      const d = new Date();
      d.setHours(12, 0, 0, 0);
      return d.toISOString().split('T')[0];
    },
    minDate() {
      const d = new Date();
      d.setHours(12, 0, 0, 0);
      d.setFullYear(d.getFullYear() - 120);
      return d.toISOString().split('T')[0];
    },
    currentCoverPhoto() {
      return this.profileData?.cover_picture?.[0]?.file?.file_url || null;
    },

    hasCover() {
      return !!(
        this.cover_picture_preview ||
        (this.profileData?.cover_picture?.length &&
          this.profileData.cover_picture[0]?.file?.file_url)
      );
    },
    currentCover() {
      return (
        this.cover_picture_preview ||
        (this.profileData?.cover_picture?.length &&
          this.profileData.cover_picture[0]?.file?.file_url) ||
        null
      );
    },

    // Decide which class to apply
  },
  watch: {

    all_section: {
      immediate: true,
      handler() {
        if (this.profileData && this.all_section) {
          this.initialize_answers();
        }
      }
    },
    selectedLocation(newVal) {
      if (newVal) {
        this.location = newVal;
      }
    },
    '$route.fullPath'() {
      this.apply_profile_route_context();
      this.get_profile();
    }
  },
  methods: {
    ...customer_profile_social_methods,
    apply_profile_route_context() {
      const context = get_profile_route_context(this.$route);

      this.user.user_id = context.user_id;
      this.profile_slug = context.profile_slug;
      this.profile_type = context.profile_type;
      this.session_profile_name = '';
      this.is_owner_view = false;
      this.profileData = {};
      this.reports = [];
      this.followers_list = [];
      this.activeTab = 'posts';
    },
    is_enabled_feature(value) {
      return value === true || value === 'true' || value === 1 || value === '1';
    },
    clear_profile_page_loading_timeout() {
      if (this.profile_page_loading_timeout) {
        clearTimeout(this.profile_page_loading_timeout);
        this.profile_page_loading_timeout = null;
      }
    },
    stop_profile_page_loader() {
      this.clear_profile_page_loading_timeout();
      this.profile_page_loading = false;
      this.isLoading = false;
    },
    refresh_profile_related_content() {
      try {
        this.get_rating();
      } catch (error) {
        console.error('Failed to refresh profile rating:', error);
      }

      try {
        this.filter_reports();
      } catch (error) {
        console.error('Failed to refresh profile reports:', error);
      }

      try {
        this.initialize_answers();
      } catch (error) {
        console.error('Failed to initialize profile answers:', error);
      }
    },
    get_loaded_profile_user_id() {
      return this.profileData?.user?.id || '';
    },
    get_loaded_profile_id() {
      return this.profileData?.base_profile?.id  || '';
    },
    get_normalized_base_profile_id(profile_data = {}) {
      return profile_data.base_profile_id || profile_data.profile_id || profile_data.id;
    },
    get_existing_profile_user(profile_data = {}) {
      return profile_data.user || profile_data.base_profile?.user || profile_data.base_profile?.creater;
    },
    get_normalized_profile_user(profile_data = {}) {
      return this.get_existing_profile_user(profile_data) || {
        id: profile_data.id,
        first_name: profile_data.first_name,
        last_name: profile_data.last_name,
        email: profile_data.email,
        phone_number: profile_data.phone_number,
        profile_picture: profile_data.profile_picture,
        is_blocked: profile_data.is_blocked,
      };
    },
    get_normalized_base_profile(profile_data = {}, user = {}) {
      return profile_data.base_profile || {
        id: this.get_normalized_base_profile_id(profile_data),
        profile_type: 'personal',
        creater: user,
        user,
      };
    },
    get_normalized_profile_email(profile_data = {}) {
      return profile_data.email || '';
    },
    get_normalized_profile_phone(profile_data = {}) {
      return profile_data.phone_number || '';
    },
    get_normalized_profile_socials(profile_data = {}) {
      return profile_data.social_profiles || [];
    },
    get_normalized_profile_files(profile_data = {}) {
      return profile_data.profile_files || [];
    },
    get_normalized_profile_visibility(profile_data = {}) {
      return profile_data.visibility || {};
    },
    normalize_profile_data(profile_data = {}) {
      const user = this.get_normalized_profile_user(profile_data);

      return ({
        ...profile_data,
        user,
        email: this.get_normalized_profile_email(profile_data),
        phone_number: this.get_normalized_profile_phone(profile_data),
        social_profiles: this.get_normalized_profile_socials(profile_data),
        profile_files: this.get_normalized_profile_files(profile_data),
        visibility: this.get_normalized_profile_visibility(profile_data),
        base_profile: this.get_normalized_base_profile(profile_data, user),
      });
    },
    fetch_profiles_when_ready() {
      if (!this.user.user_id || !this.type_of_profile.length) return;

      this.fetchProfiles();
    },
    bind_profile_modal_location_autocomplete() {
      this.$nextTick(() => {
        const profile_modal = document.getElementById('profile_modal');
        if (!profile_modal || this.profile_modal_location_handler) {
          return;
        }

        this.profile_modal_location_handler = () => this.load_profile_location_autocomplete();
        profile_modal.addEventListener('shown.bs.modal', this.profile_modal_location_handler);
      });
    },
    load_profile_location_autocomplete() {
      if (window.google?.maps?.places) {
        this.$nextTick(() => this.initialize_profile_location_autocomplete());
        return;
      }

      const existing_script = document.getElementById('googleMapsPlacesScript')
        || document.getElementById('googleMapsScript');
      if (existing_script) {
        existing_script.addEventListener('load', () => {
          this.$nextTick(() => this.initialize_profile_location_autocomplete());
        }, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.id = 'googleMapsPlacesScript';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places&v=weekly`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.$nextTick(() => this.initialize_profile_location_autocomplete());
      };
      document.head.appendChild(script);
    },
    initialize_profile_location_autocomplete() {
      const input = this.$refs.profileLocationInput;
      if (!input || !window.google?.maps?.places) {
        return;
      }

      if (this.profile_location_auto_complete_input === input) {
        return;
      }

      if (window.google.maps.places.PlaceAutocompleteElement) {
        this.profile_location_auto_complete_input = input;
        return;
      }

      this.profile_location_auto_complete = new window.google.maps.places.Autocomplete(input);
      this.profile_location_auto_complete_input = input;
      this.profile_location_auto_complete.addListener('place_changed', () => {
        const place = this.profile_location_auto_complete.getPlace();
        this.location = place?.formatted_address || input.value;
      });
    },
    bind_answer_preview_modal_return() {
      $('#view_answer_modal').off('hidden.bs.modal.profileReturn');
      $('#view_answer_modal').on('hidden.bs.modal.profileReturn', () => {
        this.finish_answer_preview_loading();
        if (!this.return_to_profile_modal_after_preview) {
          return;
        }

        this.return_to_profile_modal_after_preview = false;
        setTimeout(() => {
          $('#profile_modal').modal('show');
          this.load_profile_location_autocomplete();
        }, 150);
      });
    },
    addReportToHome(newReport) {
      if (newReport) {

        newReport.total_comments = newReport.total_comments || 0;
        newReport.like_count = newReport.like_count || 0;
        if (newReport.portal.is_public === true) {
          this.reports.unshift(newReport);
        }
      }
      this.temporaryPost = null;
    },
    format_date(datestr) {
      const date = new Date(datestr);
      const day = date.getDate();

      // Calculate the ordinal suffix (st, nd, rd, th)
      const suffix = (d => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      })(day);

      // Get the textual representations
      const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
      const month = date.toLocaleDateString('en-US', { month: 'long' }); // Added Month
      const year = date.getFullYear(); // Added Year

      // Returns format: "Monday, March 16th, 2026"
      return `${weekday}, ${month} ${day}${suffix}, ${year}`;
    },
    getFileIcon(fileUrl) {
      const iconMap = [
        { extensions: ['.pdf'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337946.png' },
        { extensions: ['.doc', '.docx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337932.png' },
        { extensions: ['.xls', '.xlsx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337958.png' },
        { extensions: ['.ppt', '.pptx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337950.png' },
        { extensions: ['.html', '.htm'], icon: 'https://cdn-icons-png.flaticon.com/128/732/732212.png' },
      ];

      for (const { extensions, icon } of iconMap) {
        if (extensions.some(ext => fileUrl.includes(ext))) {
          return icon;
        }
      }

      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
    },
    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },
    getCarouselImages(report) {
      return report.report_files.filter((item) =>
        item.file.url.includes('.jpg') ||
        item.file.url.includes('.JPG') ||
        item.file.url.includes('.png') ||
        item.file.url.includes('.PNG') ||
        item.file.url.includes('.avif') ||
        item.file.url.includes('.AVIF') ||
        item.file.url.includes('.jpeg') ||
        item.file.url.includes('.JPEG') ||
        item.file.url.includes('.webp') ||
        item.file.url.includes('.WEBP')
      )
    },
    isInLibrary(fileId) {
      // Return true if the file exists in the user's library
      return this.library_resources.some(
        (doc) => doc.report_file?.file?.id === fileId
      );
    },
    getPersonalAvatar(profileData) {
      const files = profileData.profile_files || profileData.base_profile?.user?.profile?.profile_files;
      if (files?.length) {
        return files[0]?.file?.file_url || null;
      }
      return null;
    },
    add_social_row() {
      this.new_socials.push({ platform: '', url: '' });
    },

    remove_row(index) {
      this.new_socials.splice(index, 1);
    },
    calculate_distribution() {
      const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      this.all_ratings.forEach(r => {
        if (counts[r.rating] !== undefined) counts[r.rating]++;
      });

      this.start_distribution = {
        5: this.total_ratings ? Math.round((counts[5] / this.total_ratings) * 100) : 0,
        4: this.total_ratings ? Math.round((counts[4] / this.total_ratings) * 100) : 0,
        3: this.total_ratings ? Math.round((counts[3] / this.total_ratings) * 100) : 0,
        2: this.total_ratings ? Math.round((counts[2] / this.total_ratings) * 100) : 0,
        1: this.total_ratings ? Math.round((counts[1] / this.total_ratings) * 100) : 0,
      };
    },
    has_answer_for_question(q) {
      if (!this.profileData || !Array.isArray(this.profileData.answers)) return false;
      return this.profileData.answers.some(ans => {
        return ans.question && q.question && ans.question.id === q.question.id && ans.answer;
      });
    },
    is_valid_value(value) {
      return value && value.trim().toLowerCase() !== 'n/a';
    },

    isValidField(val) {
      return val && typeof val === 'string' && val.trim().toLowerCase() !== 'n/a';
    },
    can_show_profile_field(visibilityField, value) {
      if (this.isOwner) return true;
      const PROFILE_VISIBILITY_FIELDS = new Set([
        'show_email',
        'show_phone_number',
        'show_date_of_birth',
        'show_location',
        'show_title',
        'show_gender',
        'show_race',
      ]);
      const visibility = this.profileData?.visibility || {};
      return (
        PROFILE_VISIBILITY_FIELDS.has(visibilityField) &&
        Reflect.get(visibility, visibilityField) === true &&
        this.isValidField(value)
      );
    },
    can_show_profile_location() {
      return this.can_show_profile_field(
        'show_location',
        this.profileData?.location || this.profileData?.province
      );
    },
    has_visible_profile_information() {
      return (
        this.can_show_profile_field('show_email', this.profileData?.email) ||
        this.can_show_profile_field('show_phone_number', this.profileData?.phone_number) ||
        this.can_show_profile_field('show_date_of_birth', this.profileData?.date_of_birth) ||
        this.can_show_profile_location() ||
        this.can_show_profile_field('show_title', this.profileData?.title) ||
        this.can_show_profile_field('show_gender', this.profileData?.gender) ||
        this.can_show_profile_field('show_race', this.profileData?.race)
      );
    },
    triggerFileUpload() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },

    triggerFileUploadCover() {
      this.$refs.fileInputCover && this.$refs.fileInputCover.click();
    },
    onProfilePictureChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.profilePicture = file;
        this.profile_picture_preview = URL.createObjectURL(file);
        $('#image_preview_modal').modal('show');
      }
    },
    get_active_profile_picture(item) {
      const base = item?.base_profile || item;
      if (!base) return null;

      if (base.profile_type === 'personal') {
        return this.get_personal_logo(base);
      }

      if (base.profile_type === 'business') {
        return this.get_business_logo(base);
      }

      return null;
    },
    get_percentage(star) {
      if (!this.start_distribution) return 0;
      const entry = Object.entries(this.start_distribution)
        .map(([key, value]) => ({ star: Number(key), value }))
        .find(q => q.star === star);

      return entry ? entry.value : 0;
    },
    get_personal_logo(base) {
      const files = base.user?.profile?.profile_files;
      if (!files) return null;

      const pic = files.find(f => f.profile_file_type === 'profile_picture');
      return pic?.file?.url || null;
    },

    get_business_logo(base) {
      const files = base.company?.base_profile?.profile_files;
      if (!files) return null;

      const logo = files[0]?.file;
      return logo?.file_url || logo?.url || null;
    },

    profiles_modal_close() {
      this.cover_picture = null;
      this.cover_picture_preview = null;
    },

    onCoverPictureChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.cover_picture = file;
        this.cover_picture_preview = URL.createObjectURL(file);

        $('#image_view_cover').modal('show');
      }
    },
    upload_profile_picture() {
      const formData = new FormData();
      if (this.profilePicture) {
        if (this.profilePicture instanceof File) {
          formData.append('file', this.profilePicture);
        }
      }

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we upload your profile picture.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/upload_profile_picture/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          this.profile_picture_preview = response?.file?.s3_url || null;
          this.profilePicture = null;
          $('#image_preview_modal').modal('hide');

          Swal.fire({
            title: 'Profile Picture Uploaded Successful',
            text: 'Your profile picture has been uploaded successfully.',
            icon: 'success',
            timer: 1000,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            this.get_profile();


            this.$emit('customer_profile_updated');
          })
        },
        error: (xhr) => {

          let Message = xhr.responseJSON?.message || 'An error occurred while uploading the profile picture.';
          Swal.fire({
            title: 'Upload Failed',
            text: Message,
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }

      });
    },

    delete_profile_image(file_type) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (!result.isConfirmed) return;

        const payload = {
          user_id: this.user.user_id,
          file_type: file_type
        };

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/delete_profile_picture/`,
          method: "POST",
          data: JSON.stringify(payload),
          headers: {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          },
          success: () => {
            // Refresh company profile data
            this.get_profile();
            // Close the modal
            $('#image_preview_modal').modal('hide');
            $('#image_view_cover').modal('hide');
          },
          error: (err) => {
            console.error("Error deleting cover image:", err);
          }
        });
      });
    },

    open_image_cover(url) {
      if (!url) return;
      this.image_view_url = url;
      $('#image_view_cover').modal('show');
    },
    open_image_viewer(url) {
      if (!url) return;
      this.image_view_url = url;
      $('#image_preview_modal').modal('show');
    },
    is_image_file(url) {
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
    },
    is_pdf_file(url) {
      return /\.pdf$/i.test(url);
    },
    is_office_file(url) {
      return /\.(doc|docx|xls|xlsx|ppt|pptx)$/i.test(url);
    },
    open_file_answer_viewer(url, name) {
      if (!url) return;
      this.answer_file_name = name;
      this.image_view_url = url;
      this.start_answer_preview_loading();
      const profile_modal = $('#profile_modal');
      const show_preview = () => {
        setTimeout(() => {
          $('#view_answer_modal').modal('show');
          if (!this.can_render_answer_preview(name)) {
            this.finish_answer_preview_loading();
          }
        }, 150);
      };

      if (profile_modal.hasClass('show')) {
        this.return_to_profile_modal_after_preview = true;
        profile_modal.one('hidden.bs.modal', show_preview);
        profile_modal.modal('hide');
        return;
      }

      show_preview();
    },
    finish_answer_preview_loading() {
      this.clear_answer_preview_loading_timeout();
      this.answer_preview_loading = false;
    },
    start_answer_preview_loading() {
      this.clear_answer_preview_loading_timeout();
      this.answer_preview_loading = true;
      this.answer_preview_loading_timeout = setTimeout(() => {
        this.answer_preview_loading = false;
        this.answer_preview_loading_timeout = null;
      }, 6000);
    },
    clear_answer_preview_loading_timeout() {
      if (!this.answer_preview_loading_timeout) {
        return;
      }

      clearTimeout(this.answer_preview_loading_timeout);
      this.answer_preview_loading_timeout = null;
    },
    can_render_answer_preview(name) {
      return this.is_image_file(name) || this.is_pdf_file(name) || this.is_office_file(name);
    },
    get_file_answer_name(qa) {
      return qa.newFile?.name || qa.files?.[0]?.file?.name || '';
    },
    get_file_answer_url(qa) {
      if (qa.newFile) {
        if (qa.newFilePreviewUrl) {
          URL.revokeObjectURL(qa.newFilePreviewUrl);
        }
        qa.newFilePreviewUrl = URL.createObjectURL(qa.newFile);
        return qa.newFilePreviewUrl;
      }

      return qa.files?.[0]?.file?.s3_url || qa.files?.[0]?.file?.file_url || qa.files?.[0]?.file?.url || '';
    },
    view_file_answer(qa) {
      const url = this.get_file_answer_url(qa);
      const name = this.get_file_answer_name(qa);
      this.open_file_answer_viewer(url, name);
    },

    triggerFileInput(qa) {
      const fileInput = this.$refs[`fileInput_${qa.question.id}`];
      if (fileInput) {
        // Vue 3 sometimes returns array of refs if inside v-for
        Array.isArray(fileInput) ? fileInput[0].click() : fileInput.click();
      }
    },

    onFileSelect(qa, event) {
      const file = event.target.files[0];
      if (!file) return;

      // Save selected file
      qa.newFile = file;
      qa.isChanged = true;
    },
    upload_profile_banner() {
      const formData = new FormData();
      if (this.cover_picture) {
        if (this.cover_picture instanceof File) {
          formData.append('file', this.cover_picture);
        }
      }

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we upload your profile picture.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/upload_profile_banner/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          this.cover_picture_preview = response?.file?.s3_url || null;
          this.cover_picture = null;
          $('#image_view_cover').modal('hide');
          this.profiles_modal_close();

          Swal.fire({
            title: 'Cover Picture Uploaded Successful',
            text: 'Your profile picture has been uploaded successfully.',
            icon: 'success',
            timer: 1000,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            this.get_profile();
          })
        },
        error: (xhr) => {

          let Message = xhr.responseJSON?.message || 'An error occurred while uploading the banner image.';
          Swal.fire({
            title: 'Upload Failed',
            text: Message,
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });

        }

      });
    },
    displayedDescription(report) {
      if (!report.description) return '';
      // Clean description by removing the report link if present
      let cleanDesc = report.description;
      if (report.report_link && report.linkPreview) {
        cleanDesc = cleanDesc.split(report.report_link).join("").trim();
      }
      return cleanDesc;
    },
    baseUrl(post, type) {
      const baseUrl = `${window.location.origin}${this.$route.path}`;

      // Dynamically build the URL based on the type (either 'hub' or 'report')
      if (type === 'exchange_hub') {
        return `${baseUrl}?hub_id=${post.id}`;
      } else if (type === 'report') {
        return `${baseUrl}?report_id=${post.id}`;
      }
      return baseUrl
    },
    copy_report_link_to_clipboard(report) {
      const link = this.baseUrl(report, 'report');
      navigator.clipboard.writeText(link).then(() => {
        this.show_toast('Link copied to clipboard!');
      })
    },
    show_toast(message) {
      document.querySelector('#copyToast .toast-body').textContent = message;

      $('#copyToast').fadeIn(300).addClass('show');
      setTimeout(function () {
        $('#copyToast').fadeOut(300).removeClass('show');
      }, 3000);
    },
    open_business_profile(profile) {
      view_profile_helper(this.$router, profile);
    },
    view_profile(profile) {
      if (profile && typeof profile === 'object') {
        view_profile_helper(this.$router, profile);
        return;
      }

      if (profile) {
        view_profile_helper(this.$router, { id: profile });
      }
    },

    on_dynamic_tab_click(section) {

      const sectionId = section.sectionId || section.section?.id;
      this.activeTab = 'section_' + sectionId;
    },
    getUserData() {
      let user = {
        first_name: '',
        last_name: '',
        email: '',
        gender_id: '',
        date_of_birth: '',
        phone_number: '',
        user_id: '',
        newSkill: ''
      }
      return user;
    },
    get_address() {
      let address = {
        street_address: '',
        town: '',
        postal_code: '',
        province_id: '',
      }
      return address
    },
    should_open_names_update_modal() {
      return sessionStorage.getItem('open_profile_modal') === 'true' && !this.names_update_modal_opened;
    },
    open_profile_modal() {
      this.names_update_modal_opened = true;
      sessionStorage.removeItem('open_profile_modal');
      sessionStorage.removeItem('profile_target_user_id');
      sessionStorage.removeItem('profile_target_user_name');
      this.$nextTick(() => {
        $('#profile_modal').modal('show');
        this.load_profile_location_autocomplete();
      });
    },
    get_profile() {

      this.profile_page_loading = true;
      this.isLoading = true;
      this.clear_profile_page_loading_timeout();
      this.profile_page_loading_timeout = setTimeout(() => {
        console.warn('Profile request took too long. Releasing page loader.');
        this.stop_profile_page_loader();
      }, 15000);
      const profile_request_payload = this.get_profile_request_payload();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: profile_request_payload,
        success: (data) => {
          if (data.status === 'success' && data.data.profile_data) {
            this.profileData = this.normalize_profile_data(data.data.profile_data);
            this.user.user_id = this.get_loaded_profile_user_id() || this.user.user_id;
            this.user.first_name = this.profileData?.base_profile?.creater?.first_name || this.profileData?.first_name || '';
            this.user.last_name = this.profileData?.base_profile?.creater?.last_name || this.profileData?.last_name || '';
            this.user.phone_number = this.profileData?.base_profile?.creater?.phone_number || this.profileData?.phone_number || '';
            this.user.date_of_birth = this.profileData.date_of_birth || '';
            this.user.email = this.profileData.email || '';
            this.location = this.profileData.location || '';
            this.address.street_address = this.profileData.street_address || '';
            this.address.town = (this.profileData.town || '').charAt(0).toUpperCase() + (this.profileData.town || '').slice(1).toLowerCase();
            this.address.postal_code = this.profileData.postal_code || '';


            if (this.profileData.profile_files && this.profileData.profile_files.length > 0) {
              this.profile_picture_url = this.profileData.profile_files[0].file.file_url;
              this.cv = this.profileData.profile_files[0].file;
              this.file_name = this.profileData.profile_files[0].file.name;
            } else {
              this.cv = null;
            }

            for (const race of this.races) {
              if (race.race === this.profileData.race) {
                this.race_id = race.id;
                break;
              }
            }

            // Match Gender
            for (const gender of this.genders) {
              if (gender.gender === this.profileData.gender) {
                this.user.gender_id = gender.id;
                break;
              }
            }

            // Match Province
            for (const province of this.provinces) {
              if (province.province_name === this.profileData.province) {
                this.address.province_id = province.id;
                this.province_name = province.province_name;
                break;
              }
            }

            // Match Title
            for (const title of this.titles) {
              if (title.title === this.profileData.title) {
                this.title_id = title.id;
                break;
              }
            }

            this.fetch_profiles_when_ready();
          }
          if (this.profileData.visibility) {
            this.visibilitySettings = {
              ...this.visibilitySettings,
              ...this.profileData.visibility
            };
          }
        },
        error: (xhr) => {
          console.error('Failed to fetch profile:', xhr);
        },
        complete: () => {
          this.stop_profile_page_loader();
          this.refresh_profile_related_content();
          if (this.should_open_names_update_modal()) {
            this.open_profile_modal();
          }
        },
      });
    },
    get_profile_request_payload() {
      return get_profile_request_payload({
        route: this.$route,
        profile_type: this.profile_type,
        profile_slug: this.profile_slug,
        user_id: this.user.user_id,
      });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    fetch_memberships() {
      this.token_exists = get_token();

      const payload = { filter_values: {} };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_memberships/`,
        method: "POST",
        data: JSON.stringify(payload),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {
            "Content-Type": "application/json",
          },
        success: (response) => {
          // Defensive check, in case response.data or memberships missing
          this.membership_available =
            response?.data?.memberships && response.data.memberships.length > 0;
        },
        error: (err) => {
          console.error("Failed to fetch memberships:", err);
          this.membership_available = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    filter_reports() {
      const payload = {
        base_profile_id: this.profileData?.base_profile?.id,

      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/filter_company_reports/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {

          const status = response.status

          if (status === "success") {
            this.reports = response.data.results || [];
            for (const report of this.reports) {
              this.likedReports[report.id] = report.likes.some(
                item => item.user.id == this.user_details.user_id
              )
            }



            setTimeout(() => {
              this.loading = false;
            }, 1000);


          }

        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user.user_id) {

        this.user.user_id = this.user_details.user_id;
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_user_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify({ user_id: this.user.user_id }),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : { "Content-Type": "application/json" },
        success: (response) => {
          this.membership_payment_history = response.data.payment_history;

          this.userHasPaid = this.membership_payment_history.some(
            (payment) => payment.payment_status?.status === "paid"
          );
          this.is_cancelled = this.membership_payment_history.some(
            (payment) => payment.payment_status?.status === "cancelled"
          );

          this.is_active = this.membership_payment_history[0]?.is_active || false;
          this.membership_payment_history_id = this.membership_payment_history[0]?.id || null;
          this.membership_name = this.membership_payment_history[0]?.membership?.name || '';
          this.membership_type = this.membership_payment_history[0]?.membership?.membership_type.name || '';
          this.billing_cycle = this.membership_payment_history[0]?.membership?.billing_cycle?.name || '';
          this.membership_price = this.membership_payment_history[0]?.membership?.membership_pricing[0]?.price || 0;
          this.renewal_date = this.membership_payment_history[0]?.valid_until || null;
        },
        complete: () => {
          this.isLoading = false;
        },
      })
    },

    navigate_to_plans() {
      $('#manage-subscription-modal').modal('hide');
      // Navigate after modal is hidden
      setTimeout(() => {
        this.$router.push('/view_membership/');
      }, 100); // wait for the modal to fully close
    },
    navigate_to_manage_membership(){
      this.$router.push({name:'manage_membership', params: {
            user_id: this.user.user_id
        }});
    },
    cancel_membership() {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, cancel it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/cancel_membership/`,
            method: "POST",
            data: JSON.stringify({ membership_id: this.membership_payment_history_id }),
            headers: this.token_exists
              ? {
                Authorization: `Token ${this.getToken()}`,
                "Content-Type": "application/json",
              }
              : { "Content-Type": "application/json" },
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Membership cancelled successfully',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                })
                $('#manage-subscription-modal').modal('hide');
              }
            },
            complete: () => {
              this.isLoading = false;
            },
          })
        }
      })
    },

    getToken() {
      return get_token();
    },

    toggleCheckbox(qa, optionValue, isChecked) {
      // Ensure qa.newAnswer is an array for checkboxes
      if (!Array.isArray(qa.newAnswer)) {
        // If qa.newAnswer is a string, split by comma and trim
        if (typeof qa.newAnswer === 'string' && qa.newAnswer.length > 0) {
          qa.newAnswer = qa.newAnswer.split(',').map(opt => opt.trim());
        } else {
          qa.newAnswer = [];
        }
      }

      if (isChecked) {
        if (!qa.newAnswer.includes(optionValue)) {
          qa.newAnswer.push(optionValue);
        }
      } else {
        const index = qa.newAnswer.indexOf(optionValue);
        if (index > -1) {
          qa.newAnswer.splice(index, 1);
        }
      }
    },

    get_rating() {
      this.isLoading = true;
      const profileId = this.get_loaded_profile_id();

      if (!profileId) {
        this.isLoading = false;
        return;
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_profile_rating/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          profile_id: profileId
        }),
        success: (response) => {
          if (response.status === 'success') {
            this.rating = response.data.average_rating;
            this.total_ratings = response.data.total_count;
            this.all_ratings = response.data.ratings;
            this.all_ratings = this.all_ratings.map(item => ({
              ...item, expanded: false,
              show_replies: false,
              reply_draft: '',
              replies: item.replies || []
            }))
            // Check if logged-in user has already rated
            this.user_has_rated = this.all_ratings.some(rating =>
              String(rating.rater?.id) === String(this.active_profile_data?.id)
            );

            this.calculate_distribution();


          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    open_edit_reviews(item) {
      this.new_rating = item.rating;
      this.new_review_text = item.comment;
      this.all_ratings = this.all_ratings.filter(r => r.id !== item.id);
      this.user_has_rated = false;
      this.$nextTick(() => {
        $('#reviews-tab').tab('show');
      });
    },

    submit_rating() {
      const final_rating = this.new_rating || this.userRating;
      const final_comment = this.new_review_text || this.comment;

      if (!final_rating) return;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_profile_rating/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          user_id: this.profileData.base_profile?.id,
          rating: final_rating,   // use userRating here
          comment: final_comment,
        }),
        success: (response) => {
          if (response.status === 'success') {
            this.new_rating = 0;
            this.userRating = 0;
            this.new_review_text = '';
            this.comment = '';

            // Refresh the list
            this.get_rating();

            // Close modal if open
            $('#ratings-modal').modal('hide');
          }
        },
        error: (xhr) => {
          console.error('Error submitting rating:', xhr);

          let message = xhr.responseJSON?.message || 'An error occurred while submitting your rating.';
          Swal.fire({
            title: 'Rating Failed',
            text: message,
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }

      });
    },
    submit_reply(item) {

      if (!item.reply_draft.trim()) return

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_rating_reply/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          comment_id: item.id,
          comment: item.reply_draft,
        }),
        success: (response) => {
          if (response.status === 'success') {
            this.get_rating()
          }
        }
      });
    },
    validateFile(file) {
      const allowedTypes = ['application/pdf', 'application/msword'];

      if (allowedTypes.includes(file.type)) {
        return true;
      } else {
        return false;
      }
    },

    resetFileUpload() {
      // Reset the file upload fields
      this.cv = null;
      this.local_file_url = null;
      this.fileType = '';
      this.file_name = '';
      this.isLocalFile = false;
      this.showPreview = false;
      this.errorMessage = '';  // Reset error message
    },
    validationProfileForm() {
      this.errors = {};
      let valid = true;

      // First name
      if (!this.user.first_name || this.user.first_name.trim() === '') {
        this.errors.first_name = 'First name is required';
        valid = false;
      }

      // Last name
      if (!this.user.last_name || this.user.last_name.trim() === '') {
        this.errors.last_name = 'Last name is required';
        valid = false;
      }

      // Email
      if (!this.user.email || this.user.email.trim() === '') {
        this.errors.email = 'Email is required';
        valid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user.email)) {
        this.errors.email = 'Enter a valid email address';
        valid = false;
      }

      return valid;
    },


    getOptionValue(answerId, options) {

      if (!options || !Array.isArray(options)) {
        return null; // Return null if options is not an array
      }

      const normalizedAnswerIds = Array.isArray(answerId)
        ? answerId.map(id => (typeof id === 'string' ? parseInt(id, 10) : id))
        : [typeof answerId === 'string' ? parseInt(answerId, 10) : answerId];

      // Filter options to find all matches
      const matchedOptions = options.filter(opt => normalizedAnswerIds.includes(opt.id));

      // If answerId is an array (checkboxes), return all matched options' values
      if (Array.isArray(answerId)) {
        return matchedOptions.map(opt => opt.option);
      }
      return matchedOptions.length > 0 ? matchedOptions[0].option : null;
    },

    async save_profile_with_sections() {
      if (this.has_changed_section_answers()) {
        const saved_answers = await this.submit_all_answers();
        if (!saved_answers) {
          return;
        }
      }

      if (this.has_pending_social_links()) {
        const saved_socials = await this.save_social_profiles({
          require_link: false,
          hide_modal: false,
        });
        if (!saved_socials) {
          return;
        }
      }

      this.saveProfile();
    },

    has_changed_section_answers() {
      return this.all_section.some(section =>
        section.section?.question_sections?.some(qa => qa.isChanged)
      );
    },

    saveProfile() {

      if (!this.validationProfileForm()) {
        return;
      }

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we create the profile.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.isLoading = true;
      const formData = new FormData();
      formData.append('first_name', this.user.first_name);
      formData.append('last_name', this.user.last_name);
      formData.append('email', this.user.email);
      formData.append('date_of_birth', this.user.date_of_birth);
      formData.append('gender_id', this.user.gender_id);
      formData.append('race_id', this.race_id);
      formData.append('title_id', this.title_id);
      formData.append('phone_number', this.user.phone_number);
      formData.append('street_address', this.address.street_address);
      formData.append('location', this.location);
      formData.append('town', this.address.town);
      formData.append('postal_code', this.address.postal_code);
      formData.append('province_id', this.address.province_id);
      const answeredQuestions = this.profile_questions
        .filter(question => question.answer !== undefined && question.answer !== null)
        .map(question => ({
          question_id: question.question.id,
          // Convert checkbox answers to a comma-separated string
          answer: Array.isArray(question.answer) ? question.answer.join(', ') : question.answer
        }));
      formData.append('answers', JSON.stringify(answeredQuestions));
      formData.append('base_profile', this.profileData.base_profile?.id);

      if (this.profilePicture) {
        if (this.profilePicture instanceof File) {
          formData.append('file', this.profilePicture);
        }
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_user_profile/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (body) => {
          if (body.status === 'success') {

            this.fetch_races();
            this.fetch_gender();
            this.fetch_title();
            this.fetch_province();


            Swal.fire({
              title: 'Success',
              text: 'Profile Created Successfully',
              icon: 'success',
              timer: 1000,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.get_profile();
            });
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });

      this.isLoading = true;


      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_user_profile/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: formData,
        processData: false,
        contentType: false,


        success: (data) => {
          if (data.status === 'success') {
            // Dynamically append the updated profile info
            this.fetch_races();
            this.fetch_gender();
            this.fetch_title();
            this.fetch_province();

            Swal.fire({
              title: 'Success',
              text: 'Profile Updated Successfully',
              icon: 'success',
              timer: 1000,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.get_profile();
              $('#profile_modal').modal('hide');
            });
          }
        },
        complete: () => {
          this.isLoading = false;

        },
      })


    },


    fetch_races() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_races/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.races = response.data.race_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    fetch_gender() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_genders/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.genders = response.data.gender_data;



          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    fetch_title() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_titles/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.titles = response.data.title_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    fetch_province() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_provinces/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.provinces = response.data.province_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    fetch_social_types() {
      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_social_types/`,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            this.social_platforms = response.data
          }
        },
        error: (error) => {
          console.error("Error fetching social types:", error);
        }
      });
    },
    fetch_type_of_organization() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_organization = response.data.type_of_organization_data;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },


    // Handle checkbox answers (multiple selections allowed)
    fetchProfiles() {
      if (!this.user.user_id) return;

      this.isLoading = true;
      const payload = {
        user_id: this.user.user_id
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profiles/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload), // Pass user_id to filter profiles
        success: (response) => {
          if (response.status === 'success' && response.data.profiles) {
            this.base_profiles = response.data.profiles;
            // const current_base_id = this.profileData?.base_profile?.id;
            const personalType = this.type_of_profile.find(
              (type) => type.name.toLowerCase() === 'business'
            );

            if (personalType) {
              this.filtered_profiles = this.base_profiles.filter(
                (profile) => profile.profile_type === personalType.id
              );
            } else {
              this.filtered_profiles = [];
            }
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    fetch_type_of_profile() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_type_of_profile/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_profile = response.data.type_of_profile_data;

            this.show_questions()
            this.fetch_profiles_when_ready()

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    show_questions() {

      const personal_profile = this.type_of_profile.find(
        (profile) => profile.name.toLowerCase() === 'personal'
      );
      const payload = {
        filter_values: {
          profile_type_id: personal_profile.id,
        },
      };
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          this.profile_questions = response.data;
        },
      });
    },

    save_field_visibility() {
      const payload = {};
      payload[this.currentField] = this.currentVisibility;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_profile_visibility/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
        success: () => {
          this.get_profile()
          $('#visibility_modal').modal('hide')

        },
        error: (err) => { console.error('Error occurred:', err); }
      });
    },
    open_visibility_modal(field) {
      this.currentField = field;

      const visibilityArray = Object.entries(this.profileData.visibility || {}).map(([field, value]) => ({ field, value }));
      const setting = visibilityArray.find(s => s.field === field);
      this.currentVisibility = setting ? setting.value : false;

      this.showVisibilityModal = true;
      $('#visibility_modal').modal('show')
    },

    is_section_fully_answered(section) {
      return section?.section?.question_sections?.every(qa => {
        if (!qa.question?.is_mandatory) return true;

        const value = qa.newAnswer ?? qa.answer;

        if (Array.isArray(value)) {
          return value.some(v => v !== null && v !== undefined && v !== "");
        }

        return value !== null && value !== undefined && value.toString().trim() !== "";
      });
    },
    extendedOptions(qa) {
      const opts = qa.question.options ? [...qa.question.options] : [];

      if (qa.newAnswer && !opts.some(o => o.option === qa.newAnswer)) {
        opts.push({ id: 'custom', option: qa.newAnswer });
      }

      return opts;
    },

    submit_all_answers() {
      this.isSubmitting = true;
      const base_profile_id = this.profileData?.base_profile?.id;
      const all_qa = this.all_section.flatMap(section =>
        section.section?.question_sections || []
      );

      let has_validation_error = false;

      const isOtherVariant = (value) => {
        if (!value) return false;
        return /^others?( please specify|\(please specify\))?$/i
          .test(value.toString().trim());
      };

      const getFilteredAnswer = (combined_answers) => {
        if (Array.isArray(combined_answers)) {
          return combined_answers.filter((value, index, self) => value && self.indexOf(value) === index);
        }
        return combined_answers;
      };

      const stringifyAnswer = (value) => {
        if (Array.isArray(value)) return value.join(",");
        if (typeof value === "string") return value.trim();
        return value;
      };

      const isEmptyAnswer = (value) => {
        return !value || (Array.isArray(value) && value.length === 0);
      };

      const validateOtherAnswer = (qa, combined_answers) => {
        if (typeof combined_answers !== 'string' || !isOtherVariant(combined_answers)) return combined_answers;

        if (!qa.customAnswer?.trim()) {
          qa.validation_error = "Please specify your answer.";
          has_validation_error = true;
          return combined_answers;
        }

        qa.validation_error = null;
        return qa.customAnswer.trim();
      };

      const validateMandatoryAnswer = (qa, answer) => {
        const is_file_question =
          qa.question?.question_type?.question_type === "file" &&
          qa.newFile;

        if (qa.question?.is_mandatory && isEmptyAnswer(answer) && !is_file_question) {
          qa.validation_error = "This field is required.";
          has_validation_error = true;
        } else {
          qa.validation_error = null;
        }
      };


      const formatAnswer = (qa) => {
        let combined_answers = qa.newAnswer || qa.answer;
        combined_answers = validateOtherAnswer(qa, combined_answers);

        const filtered = getFilteredAnswer(combined_answers);
        const answer = stringifyAnswer(filtered);

        validateMandatoryAnswer(qa, answer);

        const answerObj = {
          question_id: qa.question.id,
          answer
        };

        if (qa.question.question_type?.question_type === 'file' && qa.newFile) {
          answerObj.file = qa.newFile;
          answerObj.answer = qa.newFile.name;
        }

        return answerObj;
      };


      const answers = all_qa.map(formatAnswer);

      if (has_validation_error) {
        this.isSubmitting = false;
        return Promise.resolve(false);
      }

      // Build FormData
      const formData = new FormData();
      formData.append("base_profile_id", base_profile_id);

      // Build a single array of answers
      const answersPayload = answers.map(ans => ({
        question_id: ans.question_id,
        answer: ans.answer
      }));

      // Append answers as a single JSON string
      formData.append("answers", JSON.stringify(answersPayload));

      // Append files separately with keys like file_{question_id}
      answers.forEach(ans => {
        if (ans.file) {
          formData.append(`file_${ans.question_id}`, ans.file);
        }
      });

      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/answer_questions_for_base_profile/`,
          type: "POST",
          headers: { Authorization: `Token ${get_token()}` },
          data: formData,
          processData: false,
          contentType: false,
          success: (response) => {
            if (response.status === "success") {
            for (const ans of answers) {
              const qa = all_qa.find(q => q.question.id === ans.question_id);
              const question = qa?.question;
              if (!question) continue;

              const existing = this.profileData.answers.find(a => a.question.id === ans.question_id);
              if (existing) {
                existing.answer = ans.answer;
              } else {
                this.profileData.answers.push({
                  question,
                  answer: ans.answer,
                });
              }

              // ✅ Update QA fields (custom or not)
              if (qa) {
                qa.newAnswer = ans.answer;
                if (qa.customAnswer) {
                  qa.customAnswer = "";
                  qa.showCustomInput = false;
                }
              }
            }

            // Reset editing state
            this.allEditing = false;
            all_qa.forEach(qa => {
              qa.isEditing = false;
              qa.isChanged = false;
            });
            this.get_profile()
            this.isSubmitting = false;
            resolve(true);
            return;
          }
            this.isSubmitting = false;
            resolve(false);
        },
          error: () => {
            this.isSubmitting = false;
            resolve(false);
          },
          complete: () => {
            if (this.isSubmitting) {
              this.isSubmitting = false;
            }
          }
        });
      });
    },

    initialize_answers() {
      this.all_section.forEach(section => {
        section.section?.question_sections?.forEach(qa => {
          const ansObj = this.profileData.answers?.find(ans => ans.question.id === qa.question.id);
          if (ansObj) {
            if (qa.question.question_type.question_type === 'checkbox') {
              qa.newAnswer = ansObj.answer ? ansObj.answer.split(',') : [];
            } else {
              qa.newAnswer = ansObj.answer || '';
            }

            // Populate files array if there are any
            qa.files = ansObj.files || []; // ansObj.files comes from backend (ProfileAnswerFileSerializer)
          } else {
            qa.newAnswer = qa.question.question_type.question_type === 'checkbox' ? [] : '';
            qa.files = [];
          }
          qa.isChanged = false;
        });
        const full = this.is_section_fully_answered(section);
        this.fully_answered_sections[section.section.id] = full;
      });

    },



    paginated_questions(questions) {
      const start = (this.question_page - 1) * this.questions_per_page;
      return questions.slice(start, start + this.questions_per_page);
    },
    total_puestion_pages(questions) {
      return Math.ceil(questions.length / this.questions_per_page);
    },
    change_question_page(page, section) {
      const questions = section && section.section && Array.isArray(section.section.question_sections)
        ? section.section.question_sections
        : [];
      const totalPages = this.total_puestion_pages(questions);
      if (page >= 1 && page <= totalPages) {
        this.question_page = page;
      }
    },
    // Helper to get current section's questions

    handle_next_page(section) {
      const paged_question = this.paginated_questions(section.section.question_sections);
      let hasError = false;

      paged_question.forEach(qa => {
        const val = Array.isArray(qa.newAnswer || qa.answer)
          ? (qa.newAnswer || qa.answer).filter(v => v).join(",")
          : (qa.newAnswer || qa.answer || "").toString().trim();

        if (qa.question?.is_mandatory && !val) {
          qa.validation_error = "This field is required.";
          hasError = true;
        } else {
          qa.validation_error = null;
        }
      });

      if (hasError) return;

      // Move to next page
      this.question_page++;
    },

    filteredQuestionSections(section) {
      return section.section.question_sections.filter(q => {
        const answer = this.getAnswerByQuestionId(q.question.id);
        return (
          this.isOwner || (this.has_answer_for_question(q) && ((answer?.is_visible === true && !q.question?.is_locked) || q.question?.is_mandatory === true))
        );
      });
    },

    handleTextareaInput(qa) {
      // Limit to 500 words
      const words = qa.newAnswer.trim().split(/\s+/);
      if (words.length > 500) {
        qa.newAnswer = words.slice(0, 500).join(' ');
      }

      qa.isChanged = true;
    },


    getAnswerByQuestionId(questionId) {
      if (!this.profileData || !this.profileData.answers) return null;
      return this.profileData.answers.find(a => a.question.id === questionId);
    },

    open_answer_visibility_modal(answerObj) {

      this.currentAnswer = answerObj;  // store answer object (including id)
      this.currentAnswerVisibility = answerObj.is_visible ?? true;

      this.showVisibilityModal = true;
      $('#answer_visibility_modal').modal('show');
    },

    get_followers(type) {
      this.isloading_followers = true;
      let target_base_profile_id;
      let base_profile_id;
      if (type == "followers") {
        this.type_of_followers = true
        target_base_profile_id = this.profileData?.base_profile?.id;
      } else if (type == "following") {
        this.type_of_followers = false
        base_profile_id = this.profileData?.base_profile?.id;
      }


      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_followers/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          target_base_profile_id: target_base_profile_id,
          base_profile_id: base_profile_id
        }),
        success: (response) => {
          if (response.status === 'success') {
            this.followers_list = response.data.followers;
            this.followerCount = response.data.follower_count;

            // Open the modal after successful fetch
            $('#follower_modal').modal('show')
          }
        },
        error: (xhr) => {
          console.error('Error fetching followers:', xhr.responseJSON?.message || xhr.statusText);
        },
        complete: () => {
          this.isloading_followers = false;
        },
      });
    },
    follow_profile(base_profile_id) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/follow_profile/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ target_base_profile_id: base_profile_id }),
        success: (response) => {
          if (response.status === "success") {
            this.profileData.is_following = response.is_following;
          }
        }
      });
    },

    save_answer_visibility() {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_answer_visibility_api/`, // example endpoint
        method: 'POST',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          answer_id: this.currentAnswer.id,
          is_visible: this.currentAnswerVisibility,
        }),
        success: (response) => {
          if (response.status === 'success') {
            // Update local visibility
            this.currentAnswer.is_visible = this.currentAnswerVisibility;

            const existingAnswer = this.profileData.answers.find(ans => ans.id === this.currentAnswer.id);
            if (existingAnswer) {
              existingAnswer.is_visible = this.currentAnswerVisibility;
            }

            this.showVisibilityModal = false;
            $('#answer_visibility_modal').modal('hide');
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    },


  },
};
